import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../services/auth.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-login',
  imports: [CommonModule, FormsModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent implements OnInit {

  // Modelo para login tradicional
  loginData = {
    t1_user: '',
    t1_password: ''
  };

  // Estados del componente
  loading = false;
  errorMessage = '';
  showTraditionalLogin = false;
  env = environment;

  constructor(
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.checkForErrors();
    this.checkIfAlreadyLoggedIn();
  }

  checkForErrors(): void {
    this.route.queryParams.subscribe(params => {
      if (params['error']) {
        switch (params['error']) {
          case 'invalid_domain':
            this.errorMessage = 'El correo debe pertenecer al dominio institucional (@uncp.edu.pe)';
            break;
          case 'callback_error':
            this.errorMessage = 'Error en el proceso de autenticación. Intente nuevamente.';
            break;
          case 'no_code':
            this.errorMessage = 'Autenticación cancelada o incompleta.';
            break;
          case 'token_missing':
            this.errorMessage = 'No se pudo completar la autenticación.';
            break;
          default:
            this.errorMessage = 'Error desconocido en la autenticación.';
        }
      }
    });
  }

  checkIfAlreadyLoggedIn(): void {
    if (this.authService.getToken()) {
      this.router.navigate(['/admin']);
    }
  }

  // Login con Office 365
  loginWithOffice365(): void {
    this.loading = true;
    this.errorMessage = '';
    this.authService.redirectToOffice365();
  }

  // Alternar entre login Office 365 y tradicional
  toggleLoginMethod(): void {
    this.showTraditionalLogin = !this.showTraditionalLogin;
    this.errorMessage = '';
  }
}
